import request from '@/utils/request'


//查询列表
export function photoTypeList(data) {
  return request({
    url: '/admin/photo/type/list',
    method: 'post',
    data:data
  })
}

//添加
export function photoTypeAdd(data) {
  return request({
    url: '/admin/photo/type/add',
    method: 'post',
    data:data
  })
}

//修改
export function photoTypeUpdate(data) {
  return request({
    url: '/admin/photo/type/update',
    method: 'post',
    data:data
  })
}

//删除
export function photoTypeInActiveById(params) {
  return request({
    url: '/admin/photo/type/inActiveById',
    method: 'get',
    params: params
  })
}





// WEBPACK FOOTER //
// ./src/api/storeFrontPhotoType.js